<template>
  <div class="heroBlock">
    <v-carousel cycle hide-delimiters height="auto">
      <v-carousel-item 
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      >
        <v-row class="title fill-height hidden-xs-only" align="center" justify="center">{{ item.title }}</v-row>
        <v-row class="sm_title fill-height hidden-sm-and-up" align="center" justify="center">{{ item.title }}</v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "Hero",
  data() {
    return {
      items: [
        {
          src: require("../assets/images/carousel/kitchen_1.jpg"),
          title: "Trendy styles"
        },
        {
          src: require("../assets/images/carousel/fireplace_1.jpg"),
          title: "Affordable price"
        },
        {
          src: require("../assets/images/carousel/mr_1.jpg"),
          title: "Extraordinary quality"
        },
        {
          src: require("../assets/images/carousel/office1.jpg"),
          title: "Attention to detail"
        },
        {
          src: require("../assets/images/carousel/vanity1.jpg"),
          title: "Trustworthy installation"
        }
      ]
    };
  }
};
</script>